import { computed, Directive, input, TemplateRef } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

@Directive({
    selector: '[fcpTooltip]',
    standalone: true,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    hostDirectives: [
        {
            directive: Tooltip,
            inputs: [
                'pTooltip: fcpTooltip',
                'tooltipPosition: tooltipPosition',
                'tooltipEvent: tooltipTrigger',
                'hideOnEscape: fcpHideOnEscape',
                'showDelay: showDelay',
                'hideDelay: hideDelay',
                'autoHide',
                'tooltipOptions'
            ]
        }
    ]
})
export class FcpTooltipDirective {
    private readonly tooltipDelays = {
        fast: { show: 150, hide: 150 },
        slow: { show: 1500, hide: 1500 }
    } as const;

    e2e = input<string | null>(null);
    fcpTooltip = input<string | TemplateRef<unknown>>();
    tooltipPosition = input<FcpTooltipPosition>(FcpTooltipPosition.Top);
    tooltipTrigger = input<FcpTooltipTrigger>(FcpTooltipTrigger.Hover);
    fcpHideOnEscape = input<boolean>(true);
    delayOption = input<FcpTooltipDelayOption>(FcpTooltipDelayOption.Fast);
    showDelay = computed(() => this.tooltipDelays[this.delayOption()].show);
    hideDelay = computed(() => this.tooltipDelays[this.delayOption()].hide);
}

export enum FcpTooltipPosition {
    Top = 'top',
    Right = 'right',
    Bottom = 'bottom',
    Left = 'left'
}

export enum FcpTooltipTrigger {
    Hover = 'hover',
    Focus = 'focus'
}

export enum FcpTooltipDelayOption {
    Fast = 'fast',
    Slow = 'slow'
}
